import { LocalizationProvider, TimeField } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TSetDate } from '@utils';
import React, { FC, FocusEvent, KeyboardEvent, MouseEvent, useCallback } from 'react';

interface MeetingTimeProps {
  objDates: { startDate: Date, endDate: Date; };
  setDate: TSetDate;
}

export const MeetingTime: FC<MeetingTimeProps> = ({ objDates, setDate }) => {
  const onMouseDown = (e: MouseEvent<HTMLDivElement>) => e.stopPropagation();
  const onKeyUpStart = (e: KeyboardEvent<HTMLDivElement>) => e.key === 'Enter' && setDate(e, 'start');
  const onKeyUpEnd = (e: KeyboardEvent<HTMLDivElement>) => e.key === 'Enter' && setDate(e, 'end');
  const onBlurStart = (e: FocusEvent<HTMLTextAreaElement | HTMLInputElement, Element>) => setDate(e, 'start');
  const onBlurEnd = (e: FocusEvent<HTMLTextAreaElement | HTMLInputElement, Element>) => setDate(e, 'end');

  return (
    <div
      className='meeting-time'
      onMouseDown={onMouseDown}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <TimeField
          format="HH:mm"
          value={objDates.startDate}
          onKeyUp={onKeyUpStart}
          onBlur={onBlurStart}
        />
        <div className="time-divider" />
        <TimeField
          format="HH:mm"
          value={objDates.endDate}
          onKeyUp={onKeyUpEnd}
          onBlur={onBlurEnd}
        />
      </LocalizationProvider>
    </div>);
};